import { Routes, Route } from "react-router-dom";
import Login from "./pages/auth/Login";
import AuthLayout from "./layouts/AuthLayout";
import OneTimePassword from "./pages/auth/OneTimePassword";
import SetPassword from "./pages/auth/SetPassword";
import HomeLayout from "./layouts/HomeLayout";
import Homepage from "./pages/dashboard/Homepage";
import Loans from "./pages/loans/Loans";
import Loan from "./pages/loans/Loan";
import LoanApplications from "./pages/loan-application/LoanApplications";
import LoanArrears from "./pages/arrears/LoanArrears";
import Users from "./pages/users/Users";
import User from "./pages/users/User";
import LoanProducts from "./pages/loan-products/LoanProducts";
import Reports from "./pages/reports/Reports";
import Borrrowers from "./pages/borrowers/Borrrowers";
import Unauthorized from "./components/others/Unauthorized";
import CreateLoanProduct from "./pages/loan-products/CreateLoanProduct";
import LoanProduct from "./pages/loan-products/LoanProduct";
import LoanApplication from "./pages/loan-application/LoanApplication";
import Borrower from "./pages/borrowers/Borrower";
import LoanTermsAndConditions from "./pages/terms-conditions/LoanTermsAndConditions";
import PrivacyPolicy from "./pages/terms-conditions/PrivacyPolicy";
import LoanAffidavit from "./pages/terms-conditions/LoanAffidavit";
import SetNewPassword from "./pages/auth/SetNewPassword";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ResetPassword from "./pages/auth/ResetPassword";
import Analytics from "./pages/reports/Analytics";
import Report from "./pages/reports/Report";
import EditUserPermissions from "./pages/users/EditUserPermissions";
import EditLoanProduct from "./pages/loan-products/EditLoanProduct";
import DataProtection from "./pages/terms-conditions/DataProtection";
import DebtAcknowledgement from "./pages/terms-conditions/DebtAcknowledgement";
import Profile from "./pages/profile/Profile";
import LoanAnalysis from "./pages/reports/LoanAnalysis";
import Guarantors from "./pages/guarantors/Guarantors";
import Branches from "./pages/branches/Branches";
import RequireAuth from "./layouts/RequireAuth";
import Guarantor from "./pages/guarantors/Guarantor";
import Penalties from "./pages/penalties/Penalties";
import SystemLogs from "./pages/auditlogs/SystemLogs";
import UserTrail from "./pages/users/UserTrail";
import EditBorrower from "./pages/borrowers/EditBorrower";
import Transactions from "./pages/transactions/Transactions";

function App() {
  return (
    <>
      <Routes>
        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route path="/" element={<AuthLayout />}>
          <Route index element={<Login />} />
          <Route path="/one-time-password" element={<OneTimePassword />} />
          <Route path="/set-new-password" element={<SetPassword />} />
          <Route path="/update-password" element={<SetNewPassword />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password-otp" element={<ResetPassword />} />
        </Route>

        <Route path="/dashboard" element={<HomeLayout />}>
          <Route element={<RequireAuth />}>
            <Route index element={<Homepage />} />
            <Route path="loans" element={<Loans />} />
            <Route path="loans-arrears" element={<LoanArrears />} />
            <Route path="loans-applications" element={<LoanApplications />} />
            <Route path="loan-application/:id" element={<LoanApplication />} />

            <Route path="loans/:id" element={<Loan />} />
            <Route path="system-logs" element={<SystemLogs />} />

            <Route path="users" element={<Users />} />
            <Route path="users/:id" element={<User />} />
            <Route path="users/:id/audit-trail" element={<UserTrail />} />
            <Route
              path="users/:id/edit-user-permissions"
              element={<EditUserPermissions />}
            />

            <Route path="loan-products" element={<LoanProducts />} />
            <Route path="loan-products/:id" element={<LoanProduct />} />
            <Route
              path="loan-products/:id/edit-product"
              element={<EditLoanProduct />}
            />
            <Route
              path="loan-products/create"
              element={<CreateLoanProduct />}
            />

            <Route path="reports" element={<Reports />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="reports/:name" element={<Report />} />
            <Route
              path="loan-reports/loan-analysis"
              element={<LoanAnalysis />}
            />

            <Route path="transactions" element={<Transactions />} />
            <Route path="guarantors" element={<Guarantors />} />
            <Route path="guarantors/:id" element={<Guarantor />} />
            <Route path="branches" element={<Branches />} />

            <Route path="penalties" element={<Penalties />} />

            <Route path="borrowers" element={<Borrrowers />} />
            <Route path="borrowers/:id" element={<Borrower />} />
            <Route path="borrowers/:id/edit-borrower" element={<EditBorrower />} />

            <Route
              path="terms-conditions"
              element={<LoanTermsAndConditions />}
            />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
            <Route path="loan-affidavit" element={<LoanAffidavit />} />
            <Route path="data-protection" element={<DataProtection />} />
            <Route
              path="debt-acknowledgement"
              element={<DebtAcknowledgement />}
            />

            <Route path="profile" element={<Profile />} />
          </Route>
        </Route>
      </Routes>
    </>
  );
}

export default App;
